var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNorway(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5601_120398)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 18,
    fill: "#DC251C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 4,
    height: 12,
    fill: "#F5F8FB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 4,
    width: 4,
    height: 16,
    transform: "rotate(90 16 4)",
    fill: "#F5F8FB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    width: 2,
    height: 12,
    fill: "#41479B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 5,
    width: 2,
    height: 16,
    transform: "rotate(90 16 5)",
    fill: "#41479B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5601_120398"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 18,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNorway);
export default __webpack_public_path__ + "static/media/norway.03354293.svg";
export { ForwardRef as ReactComponent };